import * as ACTION_TYPES from "./actionTypes";
import { TransactionData } from "./reducer";

/**
 * Adding transactionId to store to initiate
 * thank you page navigation
 * @param {TransactionData} payload
 * @ignore
 */
export function updateNavigation(payload: TransactionData) {
    return {
        type: ACTION_TYPES.UPDATE_NAVIGATION,
        payload,
    };
}

/**
 * Store warrantyId under payment store object
 * @param {number} payload
 * @ignore
 */
export function initiateTransaction(payload) {
    return {
        type: ACTION_TYPES.INITIATE_TRANSACTION,
        payload,
    };
}

/**
 * Validate transaction by using id
 * @param {object} payload - contains transaction Id & status
 * @ignore
 */
export function validateTransaction(payload) {
    return {
        type: ACTION_TYPES.VALIDATE_TRANSACTION,
        payload,
    };
}

/**
 * Store validate transaction response
 * @param response
 * @ignore
 */
export function updateTransactionData(response) {
    return {
        type: ACTION_TYPES.UPDATE_TRANSACTION_DATA,
        payload: response,
    };
}

/**
 * Clear transaction response in store
 * @ignore
 */
export function clearTransactionData() {
    return {
        type: ACTION_TYPES.CLEAR_TRANSACTION_DATA,
    };
}

/**
 * Update transaction failed in store
 * @ignore
 */
export function updateTransactionFailed() {
    return {
        type: ACTION_TYPES.TRANSACTION_FAILED,
    };
}

/**
 * Update init transaction
 * @ignore
 */
export function updateInitTransaction() {
    return {
        type: ACTION_TYPES.UPDATE_INIT_TRANSACTION,
    };
}

/**
 * Update init transaction completed
 * @ignore
 */
export function updateInitTransactionCompleted() {
    return {
        type: ACTION_TYPES.UPDATE_INIT_TRANSACTION_COMPLETED,
    };
}

/**
 * Remove contractorId from persist data
 * @ignore
 */
export function removeContractorIdFromPersistData() {
    return {
        type: ACTION_TYPES.REMOVE_CONTRACTOR_ID_FROM_PERSIST,
    };
}
/**
 * Remove contractorId from persist data
 * @ignore
 */
export function addContractorIdFromPersistData(payload) {
    return {
        type: ACTION_TYPES.ADD_CONTRACTOR_ID_FROM_PERSIST,
        ...payload,
    };
}

/**
 * Update isAlreadyPaymentInitiated
 * @ignore
 */
export function updateIsAlreadyPaymentInitiated() {
    return {
        type: ACTION_TYPES.UPDATE_ALREADY_PAYMENT_INITIATED,
    };
}

/**
 * Generate Full warranty pdf report
 * @param {number} warrantyId
 * @ignore
 */
export function generateFullWarranty(warrantyId: number, warrantyNumber: any) {
    return {
        type: ACTION_TYPES.GENERATE_FULL_WARRANTY,
        payload: { warrantyId, warrantyNumber },
    };
}

export function generateFullWarrantyDownloaded() {
    return {
        type: ACTION_TYPES.GENERATE_FULL_WARRANTY_DOWNLOADED,
    };
}

/**
 * Generate Summary warranty pdf report
 * @param {number} warrantyId
 * @ignore
 */
 export function generateSummaryWarranty(warrantyId: number, warrantyNumber: any) {
    return {
        type: ACTION_TYPES.GENERATE_SUMMARY_WARRANTY,
        payload: { warrantyId, warrantyNumber },
    };
}

export function generateSummaryWarrantyDownloaded() {
    return {
        type: ACTION_TYPES.GENERATE_SUMMARY_WARRANTY_DOWNLOADED,
    };
}

/**
 * Download Summary warranty pdf
 * @param {number} warrantyNumber, {number} WarrantyId
 * @ignore
 */
export function downloadSummaryPdf(warrantyId: number, warrantyNumber: any) {
    return {
        type: ACTION_TYPES.DOWNLOAD_SUMMARY_PDF,
        payload: { warrantyId, warrantyNumber },
    };
}

export function downloadSummaryPdfSuccess() {
    return {
        type: ACTION_TYPES.DOWNLOAD_SUMMARY_PDF_SUCCESS,
    };
}

export function downloadSummaryPdfFailure() {
    return {
        type: ACTION_TYPES.DOWNLOAD_SUMMARY_PDF_FAILURE,
    };
}